export const CoreRoutes = {
	home: '/',
	login: '/login',
	logout: '/log-out',
	sales: '/sales',
	changeEmail: '/change-email',
	confirmEmail: '/confirm-email',
	resetPassword: '/reset-password',
	requestPasswordReset: '/request-password-reset',
	products: '/products',
	administration: '/administration',
	organization: '/organization',
	partners: '/partners',
	customers: '/customers',
	reporting: '/reporting',
	accountInformation: '/account-information',
	error: '/error',
	wildcard:'*'
};
